
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import FieldWrapper from './FieldWrapper';

const useStyles = makeStyles(theme => ({
  textField: {
    '& .MuiOutlinedInput-root': {
      fontSize: 14,
      backgroundColor: ({ disabled, error }) => 
        disabled ? '#F4F5F7' :
        error ? '#FEE' :
        'white',
    },
    '& .MuiOutlinedInput-input': {
      padding: 12,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: ({ error }) => 
        error ? theme.palette.error.main : theme.palette.grey[300],
      transition: 'border-color 0.2s ease-in-out',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: ({ disabled, error }) => 
        disabled ? theme.palette.grey[300] :
        error ? theme.palette.error.main : 
        theme.palette.primary.main,
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: ({ disabled, error }) => 
        disabled ? `${theme.palette.grey[300]} !important` :
        error ? `${theme.palette.error.main} !important` : 
        `${theme.palette.primary.main} !important`,
      borderWidth: 2,
    },
    '& .Mui-disabled': {
      backgroundColor: '#F4F5F7',
      cursor: 'not-allowed',
    },
  },
}));

export const InputField = ({ 
  label, 
  error, 
  helperText, 
  fullWidth, 
  required, 
  disabled, 
  ...props 
}) => {
  const classes = useStyles({ disabled, error });

  return (
    <FieldWrapper
      label={label}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      required={required}
    >
      <TextField
        className={classes.textField}
        variant="outlined"
        fullWidth={fullWidth}
        required={required}
        error={!!error}
        disabled={disabled}
        {...props}
      />
    </FieldWrapper>
  );
};

InputField.propTypes = {
  ...FieldWrapper.propTypes,
  disabled: PropTypes.bool,
};

export default InputField;
